module.exports = __webpack_public_path__ + "static/img/ios_ur.36f74789.png";